import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	targetRequired,
	qsRequired,
	trapFocus,
	removeTrapFocus,
	getAttributeOrThrow,
	qsaOptional,
} from '@/scripts/core/global'

export class ProductTooltip extends UcoastEl {
	static htmlSelector = 'product-tooltip'
	tooltipEl: HTMLElement
	triggerEl: HTMLElement
	mouseHasEnteredTooltip = false
	isOpen = false
	tooltipId: string

	constructor() {
		super()
		this.tooltipId = getAttributeOrThrow('data-tooltip-id', this)

		this.tooltipEl = qsRequired('[data-uc-product-tooltip-content]', this)
		this.triggerEl = qsRequired('[data-uc-product-tooltip-trigger]', this)
		this.tooltipEl.addEventListener('click', (e) => {
			e.preventDefault()
			const target = targetRequired(e)
			console.log({ target })
			if (!(target instanceof HTMLAnchorElement)) {
				return
			}
			const href = target.getAttribute('href')
			if (!href) {
				return
			}
			window.location.href = href
		})
		this.tooltipEl.addEventListener('mouseover', () => {
			this.mouseHasEnteredTooltip = true
		})
		this.tooltipEl.addEventListener('mouseleave', () => {
			if (!this.isOpen || !this.mouseHasEnteredTooltip) {
				return
			}
			this.close()
		})
		this.triggerEl.addEventListener('mouseover', () => {
			if (this.isOpen) {
				return
			}
			this.open()
		})
	}
	open() {
		const allOtherTooltips = qsaOptional<ProductTooltip>(
			`product-tooltip:not([data-tooltip-id="${this.tooltipId}"])`
		)
		allOtherTooltips?.forEach((tooltip) => {
			tooltip.close()
		})
		this.mouseHasEnteredTooltip = false
		this.isOpen = true
		this.tooltipEl.classList.add('active')
		this.classList.add('active')
		trapFocus(this.tooltipEl, this.triggerEl)
	}
	close() {
		this.mouseHasEnteredTooltip = false
		this.isOpen = false
		this.tooltipEl.classList.remove('active')
		this.classList.remove('active')
		removeTrapFocus(this.triggerEl)
	}
}
